import { getRequest, postRequest, URL } from "shared/utils";
import * as types from "./actionTypes";

const queryParms = (request) => {
  const {
    clientId,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
    searchKeyword,
    noticeDateStart,
    noticeDateEnd,
    filters,
  } = request;

  let parms = `?clientId=${clientId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

  if (sortColumn) {
    parms += `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
  }

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (noticeDateStart && noticeDateEnd) {
    parms += `&noticeDateStart=${noticeDateStart}&noticeDateEnd=${noticeDateEnd}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key, index) => {
      var filterBy = filters[key];

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${f}`;
        });
      }
    });
  }

  return parms;
};

export function getLeases(requestWithParams) {
  const url = `${URL.lease}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASES,
    payload: request,
  };
}

export function getLeaseSpreadsheet(parms) {
  var utcOffset = new Date().getTimezoneOffset() / 60;

  utcOffset = utcOffset * -1;

  let url = `${URL.lease}/spreadsheet`;

  const { filters } = parms;

  delete parms.filters;

  for (var prop in filters) {
    if (Array.isArray(filters[prop]) && filters[prop].length === 0)
      delete filters[prop];
  }

  const request = postRequest(
    url,
    { ...parms, ...filters, utcOffset },
    false,
    "blob"
  );

  return {
    type: types.GET_LEASE_SPREADSHEET,
    payload: request,
  };
}

export function getLease(id) {
  const url = `${URL.lease}/${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE,
    payload: request,
  };
}

export function getLeaseFilterOptions(clientId) {
  const url = `${URL.lease}/filterOptions?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_FILTER_OPTIONS,
    payload: request,
  };
}

export function getLeaseCities(clientId) {
  const url = `${URL.lease}/cities?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_CITIES,
    payload: request,
  };
}

export function getLeaseStateProvinces(clientId) {
  const url = `${URL.lease}/states?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_STATE_PROVINCES,
    payload: request,
  };
}

export function getLeaseCountries(clientId) {
  const url = `${URL.lease}/countries?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_COUNTRIES,
    payload: request,
  };
}

export function getLeaseTypes(clientId) {
  const url = `${URL.lease}/types?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_TYPES,
    payload: request,
  };
}

export function getLeaseStatuses(clientId) {
  const url = `${URL.lease}/statuses?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_STATUSES,
    payload: request,
  };
}

export function getLeaseEventTypes(clientId) {
  const url = `${URL.lease}/eventTypes?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT_TYPES,
    payload: request,
  };
}

export function getLeaseTenureTypes(clientId) {
  const url = `${URL.lease}/tenureTypes?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TENURE_TYPES,
    payload: request,
  };
}

export function getRelatedLeaseEvents(leaseId) {
  const url = `${URL.lease}/${leaseId}/leaseEvents`;

  const request = getRequest(url);

  return {
    type: types.GET_RELATED_LEASE_EVENTS,
    payload: request,
  };
}

export function getAllLeases(requestWithParams) {
  const url = `${URL.lease}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_LEASES,
    payload: request,
  };
}

export function getLeasePageSize(userId, tableName) {
  const url = `${URL.lease}/pageSize?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_PAGE_SIZE,
    payload: request,
  };
}
